import React from "react"

function MyFooter() {
    return(
        <div>
            <p>...</p>
            <footer> Made with &#9829; by <a href ="https://linktr.ee/sanskaromar" target="blank">Sanskar</a></footer>
        </div>
    )
}
export default MyFooter